import { render, staticRenderFns } from "./pt-br.vue?vue&type=template&id=4a1122bf&"
import script from "./pt-br.vue?vue&type=script&lang=js&"
export * from "./pt-br.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports